import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesDropdown, setServicesDropdown] = useState(false);
  const [projectsDropdown, setProjectsDropdown] = useState(false);

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        <nav className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2">
              <div className="text-2xl font-bold">
                <span className="text-black">ATHENA</span>
                <span className="text-accent"> PROCESS</span>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <Link
                to="/"
                className={`nav-link font-medium ${isActive('/') ? 'text-accent' : 'text-gray-700'}`}
              >
                Home
              </Link>
              <Link
                to="/about"
                className={`nav-link font-medium ${isActive('/about') ? 'text-accent' : 'text-gray-700'}`}
              >
                About
              </Link>
              
              {/* Services Dropdown */}
              <div
                className="relative"
                onMouseEnter={() => setServicesDropdown(true)}
                onMouseLeave={() => setServicesDropdown(false)}
              >
                <Link
                  to="/services"
                  className={`nav-link font-medium ${location.pathname.startsWith('/services') ? 'text-accent' : 'text-gray-700'}`}
                >
                  Services ▾
                </Link>
                {servicesDropdown && (
                  <div className="absolute top-full left-0 mt-2 w-64 bg-white shadow-xl rounded-lg py-2 border border-gray-100">
                    <Link to="/services/evaporators" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Evaporators</Link>
                    <Link to="/services/dryers" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Dryers</Link>
                    <Link to="/services/dairy-equipment" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Dairy Equipment</Link>
                    <Link to="/services/mixers" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Mixers</Link>
                    <Link to="/services/accessories" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Accessories</Link>
                    <Link to="/services/herbal-extraction" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Herbal Extraction</Link>
                  </div>
                )}
              </div>

              {/* Projects Dropdown */}
              <div
                className="relative"
                onMouseEnter={() => setProjectsDropdown(true)}
                onMouseLeave={() => setProjectsDropdown(false)}
              >
                <Link
                  to="/projects"
                  className={`nav-link font-medium ${location.pathname.startsWith('/projects') ? 'text-accent' : 'text-gray-700'}`}
                >
                  Projects ▾
                </Link>
                {projectsDropdown && (
                  <div className="absolute top-full left-0 mt-2 w-64 bg-white shadow-xl rounded-lg py-2 border border-gray-100 max-h-96 overflow-y-auto">
                    <div className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase">Dairy Processing</div>
                    <Link to="/projects/liquid-milk" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Liquid Milk Plant</Link>
                    <Link to="/projects/ghee" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Ghee Plant</Link>
                    <Link to="/projects/dahi-lassi" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Dahi/Lassi/Yoghurt</Link>
                    <Link to="/projects/smp-wmp" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">SMP/WMP/Dairy Whitener</Link>
                    <Link to="/projects/paneer" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Paneer Plant</Link>
                    <Link to="/projects/khoa" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Khoa Plant</Link>
                    <Link to="/projects/ice-cream" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Ice Cream Plant</Link>
                    <Link to="/projects/sweetened-milk" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Sweetened Condensed Milk</Link>
                    <Link to="/projects/butter-oil" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Butter Oil/AMF Plant</Link>
                    <Link to="/projects/casein" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Casein/WPC Plant</Link>
                    <Link to="/projects/malted-milk" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Malted Milk Powder</Link>
                    <Link to="/projects/flavored-milk" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Flavored Milk Plant</Link>
                    <div className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase mt-2">Other Industries</div>
                    <Link to="/projects/effluent" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Effluent Treatment</Link>
                    <Link to="/projects/tea-coffee" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Tea & Coffee Plant</Link>
                    <Link to="/projects/starch-malt" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Starch & Malt Extraction</Link>
                    <Link to="/projects/fruits-vegetables" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-accent">Fruits & Vegetables</Link>
                  </div>
                )}
              </div>

              <Link
                to="/contact"
                className={`nav-link font-medium ${isActive('/contact') ? 'text-accent' : 'text-gray-700'}`}
              >
                Contact
              </Link>

              <Link
                to="/contact"
                className="btn-primary px-6 py-2 rounded-lg font-medium"
              >
                Get Quote
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-gray-700"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4">
              <Link to="/" className="block py-2 text-gray-700 hover:text-accent">Home</Link>
              <Link to="/about" className="block py-2 text-gray-700 hover:text-accent">About</Link>
              <Link to="/services" className="block py-2 text-gray-700 hover:text-accent">Services</Link>
              <Link to="/projects" className="block py-2 text-gray-700 hover:text-accent">Projects</Link>
              <Link to="/contact" className="block py-2 text-gray-700 hover:text-accent">Contact</Link>
            </div>
          )}
        </nav>
      </header>

      {/* Main Content */}
      <main className="flex-grow">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-black text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4">
                <span className="text-white">ATHENA</span>
                <span className="text-accent"> PROCESS</span>
              </h3>
              <p className="text-gray-400 text-sm">
                ISO 9001:2015 & ISO 14001:2015 Certified Company
              </p>
              <p className="text-green mt-2 font-semibold">Excellence in Engineering</p>
            </div>
            <div>
              <h4 className="font-semibold mb-4 text-accent">Quick Links</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/about" className="text-gray-400 hover:text-white">About Us</Link></li>
                <li><Link to="/services" className="text-gray-400 hover:text-white">Services</Link></li>
                <li><Link to="/projects" className="text-gray-400 hover:text-white">Projects</Link></li>
                <li><Link to="/contact" className="text-gray-400 hover:text-white">Contact</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4 text-accent">Services</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/services/evaporators" className="text-gray-400 hover:text-white">Evaporators</Link></li>
                <li><Link to="/services/dryers" className="text-gray-400 hover:text-white">Dryers</Link></li>
                <li><Link to="/services/dairy-equipment" className="text-gray-400 hover:text-white">Dairy Equipment</Link></li>
                <li><Link to="/services/mixers" className="text-gray-400 hover:text-white">Mixers</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4 text-accent">Contact</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li>Palwal, Haryana, India</li>
                <li>Delhi-Mathura Highway</li>
                <li className="text-green">24+ Years Experience</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm">
            <p>&copy; 2024 Athena Process Design & Manufacturing. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;